export default __webpack_public_path__ + "static/media/ic_send_disable.dde3da40.svg";